<template>
  <div>
    <!-- 子路由出口 -->
    <router-view></router-view>
    <van-tabbar
      v-model="active"
      class="layout-tabbar"
      route
      @change="changeTab"
      :placeholder="true"
      :safe-area-inset-bottom="true"
    >
      <van-tabbar-item to="/homePage">
        <!-- <i slot="icon" class="toutiao toutiao-shouye"></i> -->
        <!-- <i class="iconfont" slot="icon">&#xe629;</i> -->
        <template #icon="props">
          <img src="@/assets/img/shouye1.png" alt="" v-if="props.active" />
          <img src="@/assets/img/shouye2.png" v-else alt="" />
        </template>
        首页
      </van-tabbar-item>
      <van-tabbar-item to="/servicePage">
        <!-- <i class="iconfont" slot="icon">&#xebbe;</i> -->
        <template #icon="props">
          <img src="@/assets/img/fuwu1.png" alt="" v-if="props.active" />
          <img src="@/assets/img/fuwu2.png" v-else alt="" />
        </template>
        服务
      </van-tabbar-item>
      <van-tabbar-item to="/myPage">
        <!-- <i class="iconfont" slot="icon">&#xe62f;</i> -->
        <template #icon="props">
          <img src="@/assets/img/wode1.png" alt="" v-if="props.active" />
          <img src="@/assets/img/wode2.png" v-else alt="" />
        </template>
        我的
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
    };
  },
  methods: {
    changeTab(e) {},
  },
};
</script>

<style scoped>
.iconfont {
  font-size: 40px;
}
::v-deep .van-tabbar-item--active .van-tabbar-item__icon{
  scale: 1.1;
}
</style>
